// Simple session hook backed by Supabase Auth.
// Returns { session, user, loading, isAdmin } and refreshes on auth changes.

import { useEffect, useState } from 'react';
import { supabase, supabaseConfigured } from './supabase';

export function useSession() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let unsub;
    if (!supabaseConfigured) {
      setLoading(false);
      return;
    }
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session ?? null);
      setLoading(false);
    });
    const { data } = supabase.auth.onAuthStateChange((_event, s) => {
      setSession(s ?? null);
    });
    unsub = data.subscription;
    return () => unsub && unsub.unsubscribe();
  }, []);

  useEffect(() => {
    if (!supabaseConfigured || !session?.user) {
      setIsAdmin(false);
      return;
    }
    supabase
      .from('admin_users')
      .select('role')
      .eq('user_id', session.user.id)
      .maybeSingle()
      .then(({ data }) => setIsAdmin(Boolean(data)));
  }, [session?.user?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    session,
    user: session?.user ?? null,
    loading,
    isAdmin,
    configured: supabaseConfigured,
  };
}
